module.exports = __webpack_public_path__ + "img/santa.37d22447.png";